import { render, staticRenderFns } from "./IconDocPdf.vue?vue&type=template&id=6a465e60&"
import script from "./IconDocPdf.vue?vue&type=script&lang=js&"
export * from "./IconDocPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a465e60')) {
      api.createRecord('6a465e60', component.options)
    } else {
      api.reload('6a465e60', component.options)
    }
    module.hot.accept("./IconDocPdf.vue?vue&type=template&id=6a465e60&", function () {
      api.rerender('6a465e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDocPdf.vue"
export default component.exports